import editForm from './co-borrower-entity.form';
import { CustomComponentType, CustomBuilderGroups, LoanRoleType } from '../../../enums';
import { PrimaryRoleRepeaterWidgetVue } from '../primary-role-repeater-widget/primary-role-repeater-widget-vue';

export default class CoBorrowerEntityWidgetVue extends PrimaryRoleRepeaterWidgetVue {
	static schema(...extend: any) {
		return PrimaryRoleRepeaterWidgetVue.schema(
			{
				label: 'Co-Borrower',
				type: CustomComponentType.coBorrowerEntity,
				key: CustomComponentType.coBorrowerEntity,
				addAnother: 'Add a Co-Borrower'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Co-Borrower',
			group: CustomBuilderGroups.widgets,
			weight: 10,
			schema: CoBorrowerEntityWidgetVue.schema({})
		};
	}

	init() {
		this.roleType = LoanRoleType.CoBorrower;

		super.init();
	}
}
